import { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider }  from "react-bootstrap-table2-paginator";
import { getAuthorities } from "../../../../../../../_helpers/Helpers";
import * as actions from "../../../../_redux/user-assignment/UserAssignmentAction";
import * as uiHelpers from "../StudentUsersUIHelpers";
import { 
  getSelectRow, 
  getHandlerTableChange,  
  NoRecordsFoundMessage, 
  PleaseWaitMessage, 
  sortCaret
} from "../../../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../../../_metronic/_partials/controls";
import { useStudentUsersUIContext } from "../StudentUsersUIContext";

export function StudentUsersTable({
  removeUsers
}) {
  // Student Users UI Context
  const studentUsersUIContext = useStudentUsersUIContext();
  const studentUsersUIProps = useMemo(() => {
    return {
      ids: studentUsersUIContext.ids,
      setIds: studentUsersUIContext.setIds,
      queryParams: studentUsersUIContext.queryParams,
      setQueryParams: studentUsersUIContext.setQueryParams
    };
  }, [studentUsersUIContext]);

  // Getting curret state of Student Users list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.userAssignment }),
    shallowEqual
  );
  const { totalCount, entities, authorities, listLoading } = currentState;
  
  // Authority Parameters
  const { isDeletionAuthorized } = getAuthorities(authorities);

  // Student Users Redux state
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.getStudentUserAndUserGroups(studentUsersUIProps.queryParams));
    return () => dispatch(actions.cleanUsers());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studentUsersUIProps.queryParams, dispatch]);

  // Table columns
  const columns = [
    {
      dataField: "tcKimlikNo",
      text: "TC Kimlik No",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "name",
      text: "Adı",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "surname",
      text: "Soyadı",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "section",
      text: "Şube",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "userGroup",
      text: "Kullanıcı Grubu",
      sort: true,
      sortCaret: sortCaret
    }
  ];

  const actionColumn = {
    dataField: "action",
    text: "İşlemler",
    formatter: columnFormatters.ActionsColumnFormatter,
    formatExtraData: {
      isDeletionAuthorized,
      removeUsers
    },
    classes: "text-center",
    headerClasses: "text-center",
    style: {
      width: "90px",
    }
  };
  
  if (isDeletionAuthorized) columns.push(actionColumn);

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: studentUsersUIProps.queryParams.pageSize,
    page: studentUsersUIProps.queryParams.pageNumber
  };
  
  return (
    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
      {({ paginationProps, paginationTableProps }) => {
        return (
          <Pagination
            isLoading={listLoading}
            paginationProps={paginationProps}
          >
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              remote
              keyField="id"
              data={entities ?? []}
              columns={columns}
              defaultSorted={uiHelpers.defaultSorted}
              onTableChange={getHandlerTableChange(
                studentUsersUIProps.setQueryParams
              )}
              selectRow={getSelectRow({
                entities,
                ids: studentUsersUIProps.ids,
                setIds: studentUsersUIProps.setIds,
                hidden: !isDeletionAuthorized
              })}
              {...paginationTableProps}
            >
              <PleaseWaitMessage entities={entities} />
              <NoRecordsFoundMessage entities={entities} />
            </BootstrapTable>
          </Pagination>
        );    
      }}
    </PaginationProvider>  
  );
}